// extracted by mini-css-extract-plugin
module.exports = {"overlapWarning":"OverrideBookingTimeDialog_overlapWarning__2GI9N"};